<template>
  <div>
    <b-navbar class="app-navbar" toggleable="md" type="dark" variant="info">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand href="#/dashboard">Salesianer Marketplace</b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">

        <b-navbar-nav>
          <b-nav-item href="#/dashboard">{{ $t("menu.dashboard") }}</b-nav-item>

          <b-nav-item href="#/my-stocks">{{$t("menu.my_stocks") }}</b-nav-item>
          <b-nav-item href="#/my-orders">{{$t("menu.my_orders") }}</b-nav-item>

          <b-nav-item-dropdown v-if="$rights.is_admin()" class="reports-menu">
            <template slot="button-content">
              {{ $t("menu.reports") }}
            </template>

            <b-dropdown-header>{{ $t("menu.report_activity") }}</b-dropdown-header>
            <b-dropdown-item href="#/reports-orders">{{$t("menu.orders") }}</b-dropdown-item>
            <b-dropdown-item href="#/reports-offers">{{$t("menu.offers") }}</b-dropdown-item>

            <b-dropdown-divider/>
            <b-dropdown-header>{{ $t("menu.report_stock_control") }}</b-dropdown-header>
            <b-dropdown-item href="#/reports-last-stock-update">{{$t("menu.last_stock_update") }}</b-dropdown-item>
            <b-dropdown-item href="#/report-unordered-products">{{$t("menu.unordered_products") }}</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="$rights.is_admin_or_power_user()" class="administration-menu">
            <template slot="button-content">
              {{ $t("menu.administration") }}
            </template>

            <b-dropdown-header>{{ $t("menu.access_management") }}</b-dropdown-header>
            <b-dropdown-item href="#/users" v-if="$rights.is_admin_or_power_user()">{{$t("menu.users") }}</b-dropdown-item>
            <b-dropdown-item href="#/power-user-allocation" v-if="$rights.is_admin_or_power_user()">{{$t("menu.power_user_allocation") }}</b-dropdown-item>

            <b-dropdown-divider v-if="$rights.is_admin()"/>
            <b-dropdown-header v-if="$rights.is_admin()">{{ $t("menu.location_setup") }}</b-dropdown-header>
            <b-dropdown-item href="#/factories" v-if="$rights.is_admin()">{{$t("menu.factories") }}</b-dropdown-item>

            <b-dropdown-divider v-if="$rights.is_admin()"/>
            <b-dropdown-header v-if="$rights.is_admin()">{{ $t("menu.catalog_setup") }}</b-dropdown-header>
            <b-dropdown-item href="#/products" v-if="$rights.is_admin()">{{$t("menu.products") }}</b-dropdown-item>
            <b-dropdown-item href="#/product-categories" v-if="$rights.is_admin()">{{$t("menu.product_categories") }}</b-dropdown-item>

            <b-dropdown-divider v-if="$rights.is_admin()"/>
            <b-dropdown-header v-if="$rights.is_admin()">{{ $t("menu.communication_setup") }}</b-dropdown-header>
            <b-dropdown-item href="#/email-templates" v-if="$rights.is_admin()">{{$t("menu.email_templates") }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown v-if="available_factories.length > 1" right class="factory-switcher">
            <template slot="button-content">
              {{ $t('menu.active_factory') }}: {{ active_factory_label }}
            </template>
            <b-dropdown-item
              v-for="factory in available_factories"
              :key="factory.Id"
              @click="change_active_factory(factory)">
              {{ format_factory(factory) }}
              <span v-if="parseInt(factory.Id) === parseInt(primary_factory_id)" class="primary-factory-mark">{{ $t('menu.primary_factory') }}</span>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="$t('menu.lang')" right>
            <b-dropdown-item
              v-for="language in supported_languages"
              :key="language.code"
              @click="change_language(language.code)">
              {{ language.label }}
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown :text="$t('menu.my_profile')" right>
            <b-dropdown-item @click="logout()">{{ $t("menu.log_out") }}</b-dropdown-item>
          </b-nav-item-dropdown>

        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

  </div>
</template>

<script>
import Vue from "vue";
import ElementUI from "element-ui";

import settings from "./../backend/LocalSettings";
import LocalSettings from './../backend/LocalSettings';

import localeen from "element-ui/lib/locale/lang/en"
import localede from "element-ui/lib/locale/lang/de"
import { EventBus } from '../backend/EventBus.js';
import { countryLabel } from "./../utils/countries";
import { SUPPORTED_LANGUAGES, normalizeLanguage } from "./../utils/languages";


export default {
  name: "mainmenu",
  props: [ "selected" ],
  data () {
    return {
      show: false,
      email: "",
      password: "",
      available_factories: [],
      active_factory_id: "",
      primary_factory_id: "",
      supported_languages: SUPPORTED_LANGUAGES,
    }
  },
  computed: {
    active_factory_label: function(){
      var active = this.available_factories.find((factory) => parseInt(factory.Id) === parseInt(this.active_factory_id));
      return active ? active.ShortCode : "";
    }
  },
  methods: {
    format_factory: function(factory) {
      if(!factory) return "";
      if(factory.Country) return factory.ShortCode + " - " + countryLabel(this, factory.Country);
      return factory.ShortCode;
    },
    load_factory_context: function(){
      if(!settings.is_logged_in()) return;
      this.$http
        .post('mystocks/factory_context', {})
        .then(function(response) {
          if(settings.verify_response(response, this.$rights)) {
            this.available_factories = response.body.Factories || [];
            this.primary_factory_id = response.body.PrimaryFactoryId || "";

            if(this.available_factories.length === 0) {
              this.active_factory_id = "";
              settings.set_active_factory_id("");
              return;
            }

            this.active_factory_id = settings.get_active_factory_id() || response.body.ActiveFactoryId || this.primary_factory_id;
            var allowed = this.available_factories.some((factory) => parseInt(factory.Id) === parseInt(this.active_factory_id));
            if(!allowed) this.active_factory_id = response.body.ActiveFactoryId || this.primary_factory_id;
            settings.set_active_factory_id(this.active_factory_id);
          }
        });
    },
    change_active_factory: function(factory){
      this.active_factory_id = factory.Id;
      settings.set_active_factory_id(factory.Id);
      EventBus.$emit('on_factory_context_change', factory.Id);
      this.$message.success(this.$t('menu.active_factory_changed') + ': ' + this.format_factory(factory));
    },
    on_factory_context_change: function(factoryId){
      if(!factoryId) return;
      this.active_factory_id = String(factoryId);
      settings.set_active_factory_id(factoryId);
    },
    logout: function() {
      settings.logout(this.$rights);
      this.$router.push("/");
    },
    change_language: function( lang_name ) {
      var locale = normalizeLanguage(lang_name);
      var oldLocale = this.$i18n.locale;
      window.localStorage.setItem('locale', locale);
      Vue.http.headers.common["Language"] = locale;
      this.$i18n.locale = locale;
      if(oldLocale !== locale) {
        window.location.reload();
      }
    }
  },
  mounted: function() {
    this.load_factory_context();
    EventBus.$on("on_factory_context_change", this.on_factory_context_change);
  },
  beforeDestroy: function() {
    EventBus.$off("on_factory_context_change", this.on_factory_context_change);
  }
};
</script>

<style lang="less" scoped>
.app-navbar {
  min-height: 56px;
  padding: 0 18px;
  background: #2695a8 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 22px rgba(18, 78, 95, 0.18);

  /deep/ .navbar-brand {
    margin-right: 22px;
    color: #ffffff;
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 0;
    white-space: nowrap;
  }

  /deep/ .nav-link {
    color: rgba(255, 255, 255, 0.74);
    font-weight: 600;
    transition: color 0.16s ease, background-color 0.16s ease;
  }

  /deep/ .nav-link:hover,
  /deep/ .show > .nav-link {
    color: #ffffff;
    background: rgba(255, 255, 255, 0.09);
    border-radius: 4px;
  }

  /deep/ .dropdown-menu {
    margin-top: 8px;
    min-width: 230px;
    border: 1px solid rgba(31, 73, 95, 0.12);
    border-radius: 8px;
    box-shadow: 0 16px 32px rgba(19, 55, 73, 0.18);
  }

  /deep/ .dropdown-header {
    padding: 8px 18px 4px;
    color: #647783;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  /deep/ .dropdown-divider {
    margin: 6px 0;
  }
}

.primary-factory-mark {
  display: inline-block;
  margin-left: 8px;
  color: #7b8790;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
}
</style>
